import { render, staticRenderFns } from "./MessagesForm.vue?vue&type=template&id=1a7c6f7e"
import script from "./MessagesForm.vue?vue&type=script&lang=js"
export * from "./MessagesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports